import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { FieldType, groupValidationIssuesByTopLevelPath, } from '@dossierhq/core';
import { Column, Delete, HoverRevealStack, Text, toFlexItemClassName } from '@dossierhq/design';
import { Fragment, useCallback, useContext, useMemo } from 'react';
import { DossierContext } from '../../contexts/DossierContext.js';
import { AdminTypePicker } from '../AdminTypePicker/AdminTypePicker.js';
import { FieldEditor } from './FieldEditor.js';
export function ComponentFieldEditor({ fieldSpec, adminOnly, value, validationIssues, dragHandle, onChange, }) {
    const handleDeleteClick = useCallback(() => onChange(null), [onChange]);
    const handleCreate = useCallback((type) => onChange({ type }), [onChange]);
    if (!value) {
        return (_jsxs(_Fragment, { children: [_jsx(AddComponentButton, { fieldSpec: fieldSpec, onComponentTypeSelected: handleCreate }), validationIssues.map((error, index) => (_jsx(Text, { textStyle: "body2", marginTop: 1, color: "danger", children: error.message }, index)))] }));
    }
    return (_jsxs(HoverRevealStack, { children: [_jsx(HoverRevealStack.Item, { top: true, right: true, children: _jsx(Delete, { onClick: handleDeleteClick }) }), _jsx(ComponentFieldEditorWithoutClear, { value: value, adminOnly: adminOnly, validationIssues: validationIssues, dragHandle: dragHandle, onChange: onChange })] }));
}
const noErrors = [];
export function ComponentFieldEditorWithoutClear({ className, value, adminOnly, validationIssues, dragHandle, onChange, }) {
    const { root: rootValidationIssues, children: fieldValidationIssues } = useMemo(() => groupValidationIssuesByTopLevelPath(validationIssues), [validationIssues]);
    const { schema } = useContext(DossierContext);
    if (!schema) {
        return null;
    }
    const { type } = value;
    const componentSpec = schema.getComponentTypeSpecification(type);
    if (!componentSpec) {
        return _jsx("div", { children: "Error" });
    }
    return (_jsxs(Column, { className: className, gap: 1, children: [_jsxs(Text, { textStyle: "body2", marginBottom: 0, children: [dragHandle, type] }), componentSpec.fields.map((valueFieldSpec) => {
                const fieldEditor = (_jsx(ComponentField, { value,
                    valueFieldSpec,
                    adminOnly: adminOnly || valueFieldSpec.adminOnly,
                    onChange,
                    validationIssues: fieldValidationIssues.get(valueFieldSpec.name) ?? noErrors }));
                return (_jsxs(Fragment, { children: [_jsx(Text, { textStyle: "subtitle1", marginBottom: 0, children: valueFieldSpec.name }), valueFieldSpec.type === FieldType.Component ? (_jsx("div", { className: "nested-value-item-indentation", children: fieldEditor })) : (fieldEditor)] }, valueFieldSpec.name));
            }), rootValidationIssues.map((error, index) => (_jsx(Text, { textStyle: "body2", marginTop: 1, color: "danger", children: error.message }, index)))] }));
}
export function AddComponentListItemButton({ fieldSpec, onAddItem, }) {
    const handleComponentTypeSelected = useCallback((type) => onAddItem({ type }), [onAddItem]);
    return (_jsx(AddComponentButton, { fieldSpec: fieldSpec, onComponentTypeSelected: handleComponentTypeSelected }));
}
function AddComponentButton({ fieldSpec, onComponentTypeSelected, }) {
    return (_jsx(AdminTypePicker, { className: toFlexItemClassName({ alignSelf: 'flex-start' }), showComponentTypes: true, componentTypes: fieldSpec.componentTypes, onTypeSelected: onComponentTypeSelected, children: "Add component" }));
}
function ComponentField({ value, valueFieldSpec, adminOnly, validationIssues, onChange, }) {
    const handleFieldChanged = useCallback((newFieldValue) => {
        const newValue = { ...value };
        newValue[valueFieldSpec.name] = newFieldValue;
        onChange(newValue);
    }, [onChange, value, valueFieldSpec.name]);
    return (_jsx(FieldEditor, { fieldSpec: valueFieldSpec, adminOnly: adminOnly, value: value[valueFieldSpec.name], validationIssues: validationIssues, onChange: handleFieldChanged }));
}
//# sourceMappingURL=ComponentFieldEditor.js.map